import { render, staticRenderFns } from "./BillsPhone.vue?vue&type=template&id=28a0d016&scoped=true&"
import script from "./BillsPhone.vue?vue&type=script&lang=js&"
export * from "./BillsPhone.vue?vue&type=script&lang=js&"
import style0 from "./BillsPhone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BillsPhone.vue?vue&type=style&index=1&id=28a0d016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0d016",
  null
  
)

export default component.exports